import { Component, OnInit } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';


@Component({
  templateUrl: './error-dialog.component.html',
})
export class ErrorDialogComponent implements OnInit {

  /** ng build --prod 対応 */
  title: string;

  /** ng build --prod 対応 */
  message: string;

  /** ng build --prod 対応 */
  detail: string;

  /**
   * コンストラクタ
   *
   * @param bsModalRef BsModalRef
   */
  constructor(
    private bsModalRef: BsModalRef,
  ) { }

  /**
   * 初期化処理
   */
  ngOnInit() {
  }

  /**
   * 閉じる処理
   */
  close() {
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/error-handler/error-dialog.component.ts